import React from 'react';
import Icon, { IconProps } from './Icon';

const GiftsIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M12.0002 7.00012H7.50024C6.8372 7.00012 6.20132 6.73673 5.73248 6.26789C5.26364 5.79905 5.00024 5.16316 5.00024 4.50012C5.00024 3.83708 5.26364 3.2012 5.73248 2.73236C6.20132 2.26351 6.8372 2.00012 7.50024 2.00012C11.0002 2.00012 12.0002 7.00012 12.0002 7.00012ZM12.0002 7.00012H16.5002C17.1633 7.00012 17.7992 6.73673 18.268 6.26789C18.7369 5.79905 19.0002 5.16316 19.0002 4.50012C19.0002 3.83708 18.7369 3.2012 18.268 2.73236C17.7992 2.26351 17.1633 2.00012 16.5002 2.00012C13.0002 2.00012 12.0002 7.00012 12.0002 7.00012ZM12.0002 7.00012L12.0002 22.0001M2.00024 14.0001H22.0002M2.00024 10.2001L2.00024 18.8001C2.00024 19.9202 2.00024 20.4803 2.21823 20.9081C2.40998 21.2844 2.71594 21.5904 3.09226 21.7821C3.52009 22.0001 4.08014 22.0001 5.20024 22.0001L18.8002 22.0001C19.9204 22.0001 20.4804 22.0001 20.9082 21.7821C21.2846 21.5904 21.5905 21.2844 21.7823 20.9081C22.0002 20.4803 22.0002 19.9202 22.0002 18.8001V10.2001C22.0002 9.08002 22.0002 8.51997 21.7823 8.09214C21.5905 7.71582 21.2846 7.40986 20.9082 7.21811C20.4804 7.00012 19.9204 7.00012 18.8002 7.00012L5.20025 7.00012C4.08014 7.00012 3.52009 7.00012 3.09226 7.21811C2.71594 7.40986 2.40998 7.71582 2.21823 8.09214C2.00024 8.51997 2.00024 9.08002 2.00024 10.2001Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default GiftsIcon;

